import React from 'react';
import * as styles from './HeadingComparisonRow.module.css';

export type HeadingComparisonRowProps = {
  label: string;
  numberReviewers: number;
};

export const HeadingComparisonRow = ({
  label,
  numberReviewers,
}: HeadingComparisonRowProps): JSX.Element => (
  <tr>
    <th
      colSpan={numberReviewers + 2}
      role="columnheader"
      className={styles.cell}
    >
      {label}
    </th>
  </tr>
);
